<div class="tlcw">
  <!-- Tire connect, tirehub and AL Inventory-->
  <div class="pb-0 pr-0 pt-0 tlcw-body overflow-auto"
    *ngIf="source === 'tireconnect' || source === 'tirehub' || source === 'autoleap'">
    <div class="tlwc-img">
      <img [src]="tire?.image || 'assets/img/tireconnect-tire.png'"
        onerror="this.onerror=null;this.src='assets/img/tireconnect-tire.png';" />
      <p class="m-0 mt-1 font-10 font-600 font-gray-500" *ngIf="tire?.brand">{{tire?.brand}}</p>
    </div>
    <div class="border-left-lightest pl-0 pt-10 tlwc-desc">
      <div class="border-bottom-lightest flex-between-start gap-2 flex-row flex-start p-0 pb-2">
        <div class="flex-column pl-2" [ngClass]="{'w-40' : source === 'autoleap' && isOpenFromQuickTireLookup}">
          <span class="font-16 font-700 truncate-text">{{tire?.displayTitle}}</span>
          <span class="font-14 font-400 font-secondary">{{tire?.brand}}</span>
        </div>

        <div class="flex-row pr-2">
          <div class="flex-column flex-start-end pr-3"
            *ngIf="(['tirehub', 'tireconnect'].includes(source) && selectedTireDetails) || (source === 'autoleap' && selectedTire)">
            <span class="badge tire-added-label">
              <i class="fas fa-check-circle mr-1"></i>
              <span>Added</span>
            </span>
          </div>

          <ng-container *ngIf="!isQTQAddOnEnable">

            <div class="flex-column flex-start-end pr-3" [hidden]="hideCost">
              <span class="font-12 font-secondary">Cost (per tire)</span>
              <span class="font-18 font-700">{{tire?.cost | currency: usd}}</span>
            </div>

            <div class="flex-column flex-start-end" *ngIf="isOpenFromQuickTireLookup || isOpenFromRO">
              <span class="font-12 font-secondary">Price (per tire)</span>
              <span class="font-18 font-700 font-primary">{{tire?.price | currency: usd}}</span>
            </div>
          </ng-container>
          <!-- QTQ Enabled section -->
          <ng-container *ngIf="isQTQAddOnEnable">

            <div class="flex-column flex-start-end">
              <span class="font-12 font-secondary">Price (x{{selectedQty}})</span>
              <span class="font-18 font-700">{{tire?.price * selectedQty | currency: usd}}</span>
            </div>

            <div class="flex-column flex-center-center pl-3 pr-3">
              <span class="font-18 font-700">+</span>
            </div>

            <div class="flex-column flex-start-end">
              <span class="font-12 font-secondary">Services</span>
              <span class="font-18 font-700">{{defaultServiceTotal | currency: usd}}</span>
            </div>

            <div class="flex-column flex-center-center pl-3 pr-3">
              <span class="font-18 font-700">+</span>
            </div>

            <div class="flex-column flex-start-center">
              <span class="font-12 font-secondary">Taxes</span>
              <span class="font-18 font-700">
                <div class="flex-column">
                  <span class="pointer" [pTooltip]="getTaxBreakDownTooltip(tire?.fetValue,(tire?.tireSalesTaxAmt * selectedQty) + taxAmtOnAdonService)" 
                    tooltipPosition="bottom"
                    [escape]="false"
                    tooltipStyleClass="fet-inuse-tooltip">{{((tire?.tireSalesTaxAmt * selectedQty) + tire?.fetValue + taxAmtOnAdonService) || 0 | currency: usd}}
                  </span>

                  <i class="far ml-1 font-14" [ngClass]="{'font-warning-800': !tire?.tireconnectFetValue, 'font-gray-65': tire?.tireconnectFetValue, 'fa-spinner rotate': isLoading, 'fa-redo pointer': !isLoading  }" *ngIf="isPassThroughTaxEnable"
                    [pTooltip]="getFETTooltip(tire?.tireconnectFetValue || 0,localFetValue, fetValueSource, tire?.tireconnectFetSource || '')"
                    tooltipPosition="right"
                    [escape]="false"
                    tooltipStyleClass="fet-inuse-tooltip" (click)="!isLoading ? getFETFromTireConnect(tire) : ''">
                  </i>
                </div>
              </span>
              
            </div>

            <div class="flex-column flex-center-center pl-3 pr-3">
              <span class="font-18 font-700">=</span>
            </div>

            <div class="flex-column flex-start-end">
              <span class="font-12 font-secondary">Out-the-door</span>
              <span class="font-18 font-700 font-primary">{{((tire?.price * selectedQty) + (defaultServiceTotal + taxAmtOnAdonService) + ((tire?.tireSalesTaxAmt * selectedQty) + tire?.fetValue || 0)) | currency: usd}}</span>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="flex-between-start single-section pl-0 ui-g-12">
        <div class="pl-2 pr-2 ui-g-4">
          <div class="flex-column">
            <span class="font-14 font-secondary">Tire size</span>
            <span class="font-14 font-600">{{tire?.size}}</span>
          </div>

          <div class="flex-column pt-2" [hidden]="source === 'autoleap'">
            <span class="font-14 font-secondary">Item no.</span>
            <span class="font-14 font-600">{{tire?.partNumber}}</span>
          </div>

          <div class="flex-column pt-2" [hidden]="!(source === 'autoleap')">
            <span class="font-14 font-secondary">Availability</span>
            <span class="font-14 font-600">{{tire?.countAvailable}}</span>
          </div>

        </div>
        <div class="pl-2 pr-2" [ngClass]="isQTQAddOnEnable ? 'ui-g-3' : 'ui-g-4'">
          <!-- QTQ enabled section -->
          <ng-container *ngIf="isQTQAddOnEnable">
            <div class="flex-column" [hidden]="source === 'autoleap'">
              <span class="font-14 font-secondary">Season & Warranty</span>
              <span class="font-14 font-600">{{seasonLabel[tire?.seasonality]}} ({{tire?.warranty}} mi)</span>
            </div>

            <div class="flex-column" [hidden]="source !== 'autoleap'">
              <span class="font-14 font-secondary">Season</span>
              <span class="font-14 font-600">{{seasonLabel[tire?.seasonality]}}</span>
            </div>

            <div class="flex-column pt-2" [hidden]="source === 'autoleap'">
              <span class="font-14 font-secondary">Earliest lead time</span>
              <span class="font-14 font-600">{{tire?.countAvailable < selectedQty ? 'Insufficient stock' : tire?.estimatedDeliveryDay}}</span>
            </div>
          </ng-container>

          <ng-contaier *ngIf="!isQTQAddOnEnable">
            <div class="flex-column">
              <span class="font-14 font-secondary">Season</span>
              <span class="font-14 font-600">{{seasonLabel[tire?.seasonality]}}</span>
            </div>

            <div class="flex-column pt-2" [hidden]="source === 'autoleap'">
              <span class="font-14 font-secondary">Speed rating</span>
              <span class="font-14 font-600">{{tire?.speedRating}}</span>
            </div>

          </ng-contaier>



          <div class="flex-column pt-2" [hidden]="!(source === 'autoleap')">
            <span class="font-14 font-600 w-40 pt-1">
              <app-input placeholder="Select Qty" theme="border" [isInvalid]="tire?.error" [selectTextOnFocus]="true" [value]="tire?.count"
                mask="00" (appChange)="handleCountChange($event)" (appFocus)="handleFocus(tire)" (appBlur)="handleBlur(tire)">
              </app-input>
            </span>
          </div>

        </div>



        <div class="pl-2 pr-2 ui-g-4" *ngIf="(source === 'tirehub' || source === 'tireconnect') && !isQTQAddOnEnable">

          <div class="flex-column">
            <span class="font-14 font-secondary">Warranty</span>
            <span class="font-14 font-600">{{tire?.warranty}} mi</span>
          </div>
        </div>

        <div class="pl-2 pr-2" *ngIf="source === 'autoleap'" [ngClass]="source === 'autoleap' ? 'ui-g-4' : ''">

          <div class="flex-column">
            <span class="font-14 font-secondary">Location</span>
            <span class="font-14 font-600 text-truncate" tooltipPosition="top" tooltipStyleClass="font-12 text-center"
              [pTooltip]="tire?.warehouse?.name">
              {{tire?.warehouse?.name}}
            </span>
          </div>

          <div class="flex-column pt-2">
            <span class="font-14 font-secondary">Total price</span>
            <span class="font-14 font-600 text-truncate">{{tire?.count * tire?.price | currency: usd}}</span>
          </div>
        </div>

        <div class="pl-2 pr-2 ui-g-5 flex-column" *ngIf="isQTQAddOnEnable" >
          <div class="flex-column">
            <span class="font-14 font-secondary"><span [hidden]="hideCost">Cost / </span>Price(each)</span>
            <span class="font-14 font-600"><span [hidden]="hideCost">{{tire?.cost | currency: usd}} /</span> {{tire?.price | currency: usd}}</span>
          </div>

          <div class="flex-column pt-2">
            <span class="font-14 font-secondary">Qty available</span>
            <span class="font-14 font-600">Local: {{tire?.localAvailable || 0}}<ng-container *ngIf="isMultiLocationEnabled"> | Other: {{tire?.otherAvailable || 0}}</ng-container><ng-container *ngIf="source !== 'autoleap'"> | Online: {{tire?.countAvailable || 0}}</ng-container></span>
          </div>
        </div>

        
      </div>
    </div>
  </div>

  <div class="tlcw-footer">
    <div class="row align-items-center">
      <div class="col-md-5">
        <a href="javascript:void(0);" *ngIf="source === 'tireconnect' || source === 'tirehub'"
          (click)="handleViewDetails(tire)">
          <span class="font-14 font-600">View&nbsp;details</span>
        </a>
      </div>

      <div class="col-md-7 flex-end-start">

        <div *ngIf="source === 'autoleap' && !isOpenFromQuickTireLookup" class="single-section">
          <div class="tire-service pr-2 pl-2">
            <app-auto-complete id="tire-service-name-dropdown-{{tire?._id}}"
              listId="tire-service-name-dropdown-list-{{tire?._id}}" label="Choose a service"
              placeholder="Select a service" field="title" scrollHeight="180px" theme="border" editableItemIdKey="_id"
              editFieldPlaceholder="Create new service" editFieldLabel="Create new service" [floatingLabel]="false"
              [hasEditableField]="true" [maxLength]="25" [hasFutureSelectionField]="false" [closeOnSelection]="true"
              [textTruncate]="true" [hasStaticUnassignedFiled]="false" [isDropdownIconVisible]="true"
              [suggestions]="serviceSuggestions" [listItemFontSize]="14" [fontSize]="14" [disabled]="!selectedTire"
              [value]="selectedTire?.service?.title" (appCompletedMethod)="handleSearch($event)"
              (appClear)="handleSearch('')" (appSelect)="handleSelectService($event)"
              (appSave)="handleServiceCreate($event)">
              <ng-template let-item let-editItem="editItem" appTemplate="item">
                <div class="tag-item flex-between-center">
                  <div>
                    <span>{{ item?.title }}</span>
                  </div>

                  <div class="tag-item-action flex-end-center">
                  </div>
                </div>
              </ng-template>
            </app-auto-complete>
          </div>
        </div>
        <button *ngIf="source === 'autoleap' && !isOpenFromQuickTireLookup" [disabled]="isAdding"
          class="btn btn-{{selectedTire? 'danger' : 'primary'}} btn-submit text-center"
          (click)="handleSelectTire(selectedTire? null : tire)">
          <span>{{ selectedTire? 'Deselect' : 'Select' }}
            <i *ngIf="isAdding" class="fal fa-spinner rotate ml-2"></i>
          </span>
        </button>

        <button *ngIf="source === 'autoleap' && isOpenFromQuickTireLookup" [disabled]="isAdding || tire?.error"
          class="btn btn-primary text-center"
          (click)="handleSelectTire(selectedTire? null : tire)">
          <span>Add to cart
            <i *ngIf="isAdding" class="fal fa-spinner rotate ml-2"></i>
          </span>
        </button>

        <ng-container *ngIf="source === 'tirehub'">
          <button *ngIf="inventoryType === 'inventory' else invByLeadTimeBtn" class="btn btn-primary text-center"
            [disabled]="isAdding" (click)="handleSelectTire(tire)">
            <span>
              Add to cart
              <i *ngIf="isAdding" class="fal fa-spinner rotate ml-2"></i>
            </span>
          </button>

          <ng-template #invByLeadTimeBtn>
            <button class="btn text-center btn-primary" [disabled]="isAdding" (click)="handleOpenLocationDialog(tire)">
              <span>
                Add to cart
                <i *ngIf="isAdding" class="fal fa-spinner rotate ml-2"></i>
              </span>
            </button>
          </ng-template>
        </ng-container>

        <div class="flex-end-start" *ngIf="source === 'tireconnect'">
          <button class="btn btn-primary text-center" [disabled]="isAdding" (click)="handleOpenLocationDialog(tire)">
            <span>Add to cart</span>
            <i *ngIf="isAdding" class="fal fa-spinner rotate ml-2"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
